import apiClient from "../../utils/apiclient";


export const ispubishedchnages=async(token:string)=>{
  return await apiClient.get('/admin/task/is_published_chnages',{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

}

 export const getalltaskbyid=async(reqBody:{
   task_id: string;
},token:string)=>{
  return await apiClient.post('/admin/task/getall-task-byid-v2',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

  
}
export const Activetasktab = async (token: string, page: number, limit: number, type:string,search:string,sortOption:string) => {
  try {
    return await apiClient.post(
      '/admin/task/get_active_tasklist_v1',
      { page, limit,type, search,sortOption }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error("Error fetching active tasks:", error);
    throw error;
  }
};

export const extendenddate=async(reqBody:{
    task_id: string;
    days:string
    start_date:string
 },token:string)=>{
   return await apiClient.post('/admin/task/extend_task_durataions_v1',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
 
 }
export const gettaskData=async(reqBody:{
    task_id: string;
    page:number;
    limit:number
    task_type:string
   
 },token:string)=>{
   return await apiClient.post('/admin/task/gettaskData',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
 
 }
